export default __webpack_public_path__ + "static/media/mark.4c11829a.svg";